module.exports = __webpack_public_path__ + "static-m/img/bindPolicyOther.ad8c4c5f.png";